module.exports = __webpack_public_path__ + "img/cover-m-slim.34e7630b.jpg";